import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';
import Button from '../../../../ui/button/index';
import classes from '../../kickstarter-shipping-popup.scss';
import { SELECT_FULFILLMENT } from '../../../../../redux/kickstarter-shipping/kickstarter-shipping-constants';
function KickstarterShippingParsing({
  validCount,
  invalidAddresses,
  uploadState,
  onCSVUpload,
  totalAmount,
  parsingProgress,
  parsingShipmentPrice,
  progressIsDone,
  onChangeStep
}) {
  const parsedPercentage = parsingProgress / totalAmount * 100;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("section", {
    className: classes.popupHeader
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.KSLabel
  }, "KICKSTARTER")), /*#__PURE__*/React.createElement("div", {
    className: classes.progress
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.progressBar
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.progressBarFill,
    style: {
      width: `${parsedPercentage}%`
    }
  })), /*#__PURE__*/React.createElement("span", {
    className: classes.progressText
  }, parsingProgress, " / ", totalAmount)), progressIsDone && validCount < totalAmount && /*#__PURE__*/React.createElement("div", {
    className: classes.invalidAddresses
  }, "Invalid addresses:", /*#__PURE__*/React.createElement("br", null), invalidAddresses.map((a, i) => /*#__PURE__*/React.createElement("div", {
    key: i
  }, `Line:${a.ind + 1}; Address: ${a.address}`))), progressIsDone && validCount < totalAmount && /*#__PURE__*/React.createElement("div", {
    className: classes.popupActions,
    style: {
      marginBottom: '20px'
    }
  }, /*#__PURE__*/React.createElement("label", {
    className: classes.uploadButtonLabel
  }, uploadState === 'loading' ?
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(CircularProgress, {
    className: classes.loader,
    color: '#fff',
    size: 60
  }) : null, /*#__PURE__*/React.createElement("span", {
    className: classes.uploadButtonText
  }, uploadState === 'loading' ? '\u00A0' : 'Upload New CSV'), /*#__PURE__*/React.createElement("input", {
    className: classes.uploadInput,
    onChange: onCSVUpload,
    type: "file",
    accept: ".csv,text/csv,text/plain"
  })), uploadState !== 'loading' ? /*#__PURE__*/React.createElement(Button, {
    className: classes.proposals_declineBtn,
    onClick: progressIsDone ? () => onChangeStep(SELECT_FULFILLMENT) : null
  }, "Continue Anyway") : null), /*#__PURE__*/React.createElement("div", {
    className: classes.popupProgress
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.progressLabel
  }, `$${parsingShipmentPrice / 100}`)));
}
export default KickstarterShippingParsing;